import React, { FunctionComponent, useState } from 'react';
import { Edit } from '@liveramp/motif/icons';
import { useDispatch } from 'react-redux';
import { toggleEditModalView } from 'shared/store/features/editWorkOrderModalSlice';
import { setSelectedWorkOrders } from 'shared/store/features/workOrdersTableSlice';
import WorkOrder from 'shared/interfaces/WorkOrder.interface';
import styles from './styles.module.scss';

interface Props {
  impressions: number | null;
  isImpressionDataNeeded: boolean;
  workOrder: WorkOrder;
}

const Impressions: FunctionComponent<Props> = ({ impressions, isImpressionDataNeeded, workOrder }) => {
  const [isMouseOver, setIsMouseOver] = useState(false);
  const dispatch = useDispatch();

  if (workOrder.pricingModel !== 'CPM') {
    return <>N/A</>;
  } else if (impressions != null && impressions > 0) {
    return <span data-test-id="no-impressions-banner">{new Intl.NumberFormat().format(impressions)}</span>;
  } else if (!isImpressionDataNeeded) {
    return <>– –</>;
  } else if (isImpressionDataNeeded) {
    return (
      <button
        type="button"
        data-test-id="work-order-impression-button"
        className={styles.impressionButton}
        onMouseEnter={() => setIsMouseOver(true)}
        onMouseLeave={() => setIsMouseOver(false)}
      >
        {isMouseOver ? (
          <div
            role="button"
            tabIndex={0}
            onClick={() => {
              dispatch(setSelectedWorkOrders({ selectedWorkOrders: [workOrder] }));
              dispatch(toggleEditModalView({ isEditWorkOrderModalOpened: true }));
            }}
          >
            <Edit
              className={styles.editIcon}
            />
            edit work order
          </div>
        ) : <div data-test-id="impression-data-needed-banner">impression data needed</div>}
      </button>
    );
  }
  return <>– –</>;
};

export default Impressions;
